import { selectLocale } from '@store/commonSlice';
import { useAppSelector } from '@store/index';
import { LANGUAGE_CODE } from '@utils/LocaleSelector';
import { DIVICE_PC_WIDTH, MOBILE_CNB_HEIGHT, PC_CNB_HEIGHT } from '@utils/constants';
import classNames from 'classnames';
import { format, parse } from 'date-fns';
import { enUS, ko } from 'date-fns/locale';
import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const DateSelect = ({ dateList, activeDate }: { dateList: string[] | undefined; activeDate: string }) => {
    const [searchParams, setSearchParams] = useSearchParams();

    const locale = useAppSelector(selectLocale);
    const dateWrapRef = useRef<HTMLDivElement>(null);
    const wrapTableRef = useRef<HTMLDivElement>(null);

    const onChange = (value: string) => {
        searchParams.set('date', value);
        setSearchParams(searchParams);
    };

    const [targetPosition, setTargetPosition] = useState(false);
    const [isPurpleLobby, setIsPurpleLobby] = useState(false);

    useEffect(() => {
        const cnbHeight = window.innerWidth < DIVICE_PC_WIDTH ? MOBILE_CNB_HEIGHT : PC_CNB_HEIGHT;
        const isNcPurple = !!document.querySelector('body')?.classList.contains('ncPurple');
        isNcPurple ? setIsPurpleLobby(true) : setIsPurpleLobby(false);

        const scrollTarget = isNcPurple ? document.querySelector('div.container') : window;
        scrollTarget?.addEventListener('scroll', () => {
            if (!wrapTableRef.current) return;

            const elScroll: number = scrollTarget instanceof Window ? scrollTarget.scrollY : scrollTarget.scrollTop;
            const targetElPosition = wrapTableRef.current.getBoundingClientRect().top + elScroll;

            setTargetPosition(isNcPurple ? elScroll >= targetElPosition : elScroll + cnbHeight >= targetElPosition);
        });

        window.addEventListener('resize', setWidth);
        setWidth();
    }, []);

    const setWidth = () => {
        const targetTimetable = document.querySelector<HTMLElement>('.wrap-timetable');
        const widthTimetable = targetTimetable?.offsetWidth;
        if (!dateWrapRef.current) return;
        dateWrapRef.current.style.width = `${widthTimetable}px`;
    };

    return (
        <div className="wrap-table h-[65px] lg:h-[77px]" ref={wrapTableRef}>
            <div
                ref={dateWrapRef}
                className={classNames(
                    {
                        'fixed w-full': targetPosition,
                        'top-[50px]': !isPurpleLobby,
                        '!top-[-1px]': isPurpleLobby,
                    },
                    'wrap-date static z-50 flex snap-x snap-mandatory overflow-x-auto scrollbar-hide bg-bg border-t-[1px] border-t-gray020 border-b-[1px] border-b-gray008 lg:top-[57px] lg:snap-none lg:justify-around lg:overscroll-x-none'
                )}
            >
                {!!dateList &&
                    dateList.map((dat, i) => {
                        const time = parse(dat, 'yyyy-MM-dd', new Date());
                        const localeObj = locale === LANGUAGE_CODE.ko ? ko : enUS;
                        const formatString = locale === LANGUAGE_CODE.ko ? 'E' : 'EEE';
                        const weekday = format(time, formatString, { locale: localeObj });

                        return (
                            <button
                                key={i + dat}
                                className={classNames(
                                    { 'active-date': activeDate === dat },
                                    'text-center snap-start w-[75px] flex-shrink-0 lg:w-auto pt-[8px] pb-[10px] lg:pt-[14px] lg:pb-[16px]'
                                )}
                                onClick={() => onChange(dat)}
                            >
                                <span className="text-sm text-black045 leading-[21px]">{weekday}</span>
                                <span className="block text-lg16 text-black045 leading-[24px] lg:text-lg18">{dat.substring(5)}</span>
                            </button>
                        );
                    })}
            </div>
        </div>
    );
};
export default DateSelect;
